import React from "react";
import useExport from "../hooks/useExport";
import { InvitesExporter } from "../../shared/SimpleExporter";

type InvitesExportProps = {
  status?: string;
  search?: string;
  showDeleted?: boolean;
};

// Exports the sent invites matching the currently selected filters
export default function InvitesExport({
  status,
  search,
  showDeleted,
}: InvitesExportProps) {
  const exportData = useExport("/administration/invites", {
    status: status || undefined,
    search: search || undefined,
    show_deleted: showDeleted ? "true" : undefined,
  });

  const handleStartExport = (e?: React.MouseEvent) => {
    e?.preventDefault();
    exportData.startExport();
  };

  return (
    <InvitesExporter
      canExport={exportData.canExport}
      status={exportData.status}
      percentage={exportData.percentage}
      files={exportData.files}
      createdAt={exportData.createdAt}
      createExport={handleStartExport}
    />
  );
}
